/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guides_DescriptionInputs */

const en_guides_description = /** @type {(inputs: Guides_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free JSON tutorials and guides. Learn JSON basics, compare formats, fix syntax errors, and master JSON for REST APIs.`)
};

const ko_guides_description = /** @type {(inputs: Guides_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 JSON 튜토리얼과 가이드. JSON 기초, 포맷 비교, 구문 오류 수정, REST API에서의 JSON 활용법을 배워보세요.`)
};

const ja_guides_description = /** @type {(inputs: Guides_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のJSONチュートリアルとガイド。JSONの基本を学び、フォーマットを比較し、構文エラーを修正し、REST APIでのJSON活用をマスターしましょう。`)
};

/**
* | output |
* | --- |
* | "Free JSON tutorials and guides. Learn JSON basics, compare formats, fix syntax errors, and master JSON for REST APIs." |
*
* @param {Guides_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guides_description = /** @type {((inputs?: Guides_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guides_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guides_description(inputs)
	if (locale === "ko") return ko_guides_description(inputs)
	return ja_guides_description(inputs)
});